import React, { FC } from "react";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AccordianWrapper from "../AccordionWrapper/AccordianWrapper";
import ExpiredModal from "../ExpiredModal";
import Carousel from "../Carousel/Carousel";
import BifoldTypeSelect from "../BifoldTypeSelect";
import ResetWarningModal from "../ResetWarningModal";
import { ArrowDropDown } from "@mui/icons-material";
import TabPanel from "../TabPanel";
import { styled } from "@mui/material";
import useTabsSelector from "./useTabsSelector";
// import WindowSelect from "../WindowSelect";

function a11yProps(index: string | number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const StyledRootDiv = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  width: "100%",
  marginTop: 20,
}));

const StyledUnitChoiceDiv = styled("div")({
  width: "100%",
  backgroundColor: "#fafafa",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const StyledFlexCenterDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const tabArray = [
  { door: "Bi-fold", label: "Bi-fold Door" },
  { door: "Slider", label: "Slider Door" },
  { door: "Swing", label: "Swing Door" },
  { door: "Pivot", label: "Pivot Door" },
  { door: "Fixed Panel", label: "Fixed Panel" },
];

interface DoorTabsProps {
  windowOrDoor: string;
  setWindowOrDoor: (choice: string) => void;
  // windowVal: string;
  // setWindowVal: (choice: string) => void;
  resetAllValues: () => void;
  editQuote: boolean;
  submitPressed: boolean;
  addDoorToSidebar: (withCheck?: boolean, ignoreUnitCheck?: boolean) => void;
  dealer: string; //used to check for all aluminum access
  email: string;
}

const DoorTabs: FC<DoorTabsProps> = ({
  windowOrDoor,
  setWindowOrDoor,
  // windowVal,
  // setWindowVal,
  resetAllValues,
  editQuote,
  submitPressed,
  addDoorToSidebar,
  dealer,
  email,
}) => {
  const {
    bifoldTabLabel,
    tabIndex,
    handleCloseReset,
    openResetModal,
    resetModalText,
    switchTabs,
    handleChange,
    handleBifoldChange,
    unitChoiceBifoldChange,
    open,
    modalText,
    theme,
    doorType,
    handleClose,
    editBtn,
    // handleWindowChange,
  } = useTabsSelector(
    windowOrDoor, 
    setWindowOrDoor, 
    resetAllValues, 
    // setWindowVal
  );

  const bfoldNonFocus = (
    <StyledFlexCenterDiv>
      <Typography>{bifoldTabLabel}</Typography>
      <ArrowDropDown />
    </StyledFlexCenterDiv>
  );

  const renderTabs = () => {
    return tabArray.map((tab) => {
      if (tab.door === "Bi-fold") {
        return (
          <Tab
            key={tab.door}
            style={{
              opacity: editBtn && !doorType.includes("Bi-fold") ? 0.4 : 1,
            }}
            value={windowOrDoor.replace("F", "f")}
            label={
              !doorType.includes("Bi-fold") ? (
                <>{bfoldNonFocus}</>
              ) : (
                <BifoldTypeSelect
                  fontSize=".875rem"
                  windowOrDoor={windowOrDoor}
                  handleChange={handleBifoldChange}
                />
              )
            }
            onClick={() => handleChange("", "Bi-fold")}
            {...a11yProps("Bi-fold")}
          />
        );
      }

      return (
        <Tab
          key={tab.door}
          style={{
            opacity: editBtn && doorType !== tab.door ? 0.4 : 1,
          }}
          value={tab.door}
          label={tab.label}
          onClick={() => handleChange("", tab.door)}
          {...a11yProps(tab.door)}
        />
      );
    });
  };

  return (
    <StyledRootDiv>
      <ResetWarningModal
        open={openResetModal}
        handleClose={handleCloseReset}
        modalText={resetModalText}
      />

      {doorType ? (
        <>
          <AppBar position="static" color="default">
            <Tabs
              value={doorType}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              {renderTabs()}
            </Tabs>
          </AppBar>

          <ExpiredModal
            open={open}
            modalText={modalText}
            changeDoor={true}
            handleClose={handleClose}
            switchTabs={switchTabs}
          />

          <TabPanel dir={theme.direction} index={tabIndex} value={tabIndex}>
            <AccordianWrapper
              resetValues={resetAllValues}
              editQuote={editQuote}
              submitPressed={submitPressed}
              addDoorToSidebar={addDoorToSidebar}
              dealer={dealer}
              email={email}
            />
          </TabPanel>
        </>
      ) : (
        <StyledUnitChoiceDiv>
          <Carousel
            reset={resetAllValues}
            bifold={windowOrDoor}
            handleBifoldChange={unitChoiceBifoldChange}
            windowOrDoor={windowOrDoor}
            // handleWindowChange={handleWindowChange}
            // windowVal={windowVal}
          />
        </StyledUnitChoiceDiv>
      )}
    </StyledRootDiv>
  );
};

export default DoorTabs;
